import styled from 'styled-components'
import { colors } from 'styles'

const RadioCustom = styled.div`
  transform: translate(-50%, -50%) scale(0.5);
  display: block;
  position: absolute;
  border: 0.3rem solid ${colors.textMain};
  border-radius: 100%;
  height: 2.5rem;
  width: 2.5rem;
  top: 50%;
  left: 1.25em;
  z-index: 1;
  transition: border 0.25s linear;

  &::before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 100%;
    height: 1.5rem;
    width: 1.5rem;
    top: 0.5rem;
    left: 0.5rem;
    margin: auto;
    transition: background 0.25s linear;
  }
`

const StyledRadio = styled.div`
  display: block;
  position: relative;
  float: left;
  width: 100%;
  height: 2rem;
  color: ${colors.textSecondary};

  input {
    position: absolute;
    visibility: hidden;

    &:checked {
      ~ label {
        color: ${colors.textMain};
      }

      ~ ${RadioCustom} {
        border: 0.3rem solid ${colors.textMain};

        &::before {
          background: ${colors.textMain};
        }
      }
    }
  }

  label {
    display: block;
    position: relative;
    z-index: 2;
    padding-left: 3.5rem;
    font-size: 1.4rem;
    cursor: pointer;
    transition: all 0.25s linear;
  }

  &:hover {
    label {
      color: ${colors.textMain};
    }

    ${RadioCustom} {
      border: 0.5rem solid ${colors.textMain};
    }
  }
`

export default StyledRadio
export { RadioCustom }
